<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.title" [separator]="false" />
    <email-margin [height]="20" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.p1" />
    <email-margin [height]="28" />
    <ng-container *mailgunIf="data.p2">
      <email-text [contents]="data.p2" />
      <email-margin [height]="28" />
    </ng-container>
    <email-text [contents]="data.contact_support_html" className="web-rt-contains-link" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
